import BaseService from "@client.services/baseService";

export default class UserService extends BaseService {
  constructor() {
    super("user", true);
  }

  async getAll() {
    return super.api("");
  }

  async create(user) {
    return super.post("", user);
  }

  async update(user) {
    return super.put(user.id, user);
  }

  async updateCostIndexPresentation(userId, isCostIndexPresentation) {
    return super.put(`${userId}/cost-index-presentation`, {
      isCostIndexPresentation,
    });
  }

  async updateLastInsightsViewed(userId) {
    return super.put(`${userId}/last-insights-viewed`);
  }

  async delete(options) {
    if (typeof options === "string") {
      return super.delete(options);
    }
    const { userId, ...deleteOptions } = options;
    return super.delete(userId, deleteOptions);
  }

  async getDescendants(userId) {
    return super.api(`${userId}/descendants`);
  }

  async getAvailableRoles() {
    return super.api(`availableRoles`);
  }
}
